var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "market-detail" }, [
    _c("div", { staticClass: "detail-header" }, [
      _c("h2", { staticClass: "detail-title" }, [
        _vm._v(_vm._s(_vm.marketData.marketName || "集市详情")),
      ]),
      _c(
        "div",
        { staticClass: "detail-status" },
        [
          _c(
            "el-tag",
            {
              attrs: {
                type: _vm.marketData.status === 0 ? "success" : "danger",
                size: "small",
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.marketData.status === 0 ? "上架中" : "已下架") +
                  " "
              ),
            ]
          ),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "detail-content" }, [
      _c("div", { staticClass: "detail-section" }, [
        _vm._m(0),
        _c(
          "div",
          { staticClass: "section-content" },
          [
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c("el-col", { attrs: { span: 12 } }, [
                  _c("div", { staticClass: "detail-item" }, [
                    _c("label", [_vm._v("商户名称：")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.marketData.merchantName || "-")),
                    ]),
                  ]),
                ]),
                _c("el-col", { attrs: { span: 12 } }, [
                  _c("div", { staticClass: "detail-item" }, [
                    _c("label", [_vm._v("集市名称：")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.marketData.marketName || "-")),
                    ]),
                  ]),
                ]),
                _c("el-col", { attrs: { span: 12 } }, [
                  _c(
                    "div",
                    { staticClass: "detail-item" },
                    [
                      _c("label", [_vm._v("集市类型：")]),
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            type:
                              _vm.marketData.marketType === 0
                                ? "success"
                                : "warning",
                            size: "mini",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.marketData.marketType === 0
                                  ? "长期"
                                  : "短期"
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _c("el-col", { attrs: { span: 12 } }, [
                  _c(
                    "div",
                    { staticClass: "detail-item" },
                    [
                      _c("label", [_vm._v("经营环境：")]),
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            type:
                              _vm.marketData.environmentType === 1
                                ? "primary"
                                : "info",
                            size: "mini",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.marketData.environmentType === 0
                                  ? "室内"
                                  : "室外"
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _c("el-col", { attrs: { span: 12 } }, [
                  _c(
                    "div",
                    { staticClass: "detail-item" },
                    [
                      _c("label", [_vm._v("集市属性：")]),
                      _c("el-tag", { attrs: { size: "mini" } }, [
                        _vm._v(
                          _vm._s(_vm.getSiteTypeName(_vm.marketData.siteType))
                        ),
                      ]),
                    ],
                    1
                  ),
                ]),
                _c("el-col", { attrs: { span: 12 } }, [
                  _c("div", { staticClass: "detail-item" }, [
                    _c("label", [_vm._v("集市面积：")]),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.marketData.area ? _vm.marketData.area + "㎡" : "-"
                        )
                      ),
                    ]),
                  ]),
                ]),
                _c("el-col", { attrs: { span: 12 } }, [
                  _c("div", { staticClass: "detail-item" }, [
                    _c("label", [_vm._v("容纳摊位数：")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.marketData.capacity || "-")),
                    ]),
                  ]),
                ]),
                _c("el-col", { attrs: { span: 24 } }, [
                  _c("div", { staticClass: "detail-item" }, [
                    _c("label", [_vm._v("详细地址：")]),
                    _c("span", [_vm._v(_vm._s(_vm.marketData.detail || "-"))]),
                  ]),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "detail-section" }, [
        _vm._m(1),
        _c("div", { staticClass: "section-content" }, [
          _vm.getAreaList() && _vm.getAreaList().length > 0
            ? _c(
                "div",
                _vm._l(_vm.getAreaList(), function (area, areaIndex) {
                  return _c(
                    "div",
                    { key: area.id || areaIndex, staticClass: "area-card" },
                    [
                      _c("div", { staticClass: "area-section" }, [
                        _c("div", { staticClass: "area-title" }, [
                          _c("h3", [_vm._v("区域" + _vm._s(areaIndex + 1))]),
                        ]),
                        _c("div", { staticClass: "area-info" }, [
                          _c("div", { staticClass: "info-row" }, [
                            _c("div", { staticClass: "info-item" }, [
                              _c("label", [_vm._v("区域名称：")]),
                              _c("span", [
                                _vm._v(_vm._s(area.areaName || "-")),
                              ]),
                            ]),
                            _c("div", { staticClass: "info-item" }, [
                              _c("label", [_vm._v("区域描述：")]),
                              _c("span", [
                                _vm._v(_vm._s(area.areaRemark || "-")),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "stall-section" }, [
                        _vm._m(2, true),
                        _vm.getStallsByAreaId(area.id) &&
                        _vm.getStallsByAreaId(area.id).length > 0
                          ? _c(
                              "div",
                              { staticClass: "stall-table-container" },
                              [
                                _c(
                                  "el-table",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      data: _vm.getStallsByAreaId(area.id),
                                      border: "",
                                      size: "small",
                                    },
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "位置编号",
                                        width: "100",
                                        align: "center",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      scope.row.stallNum ||
                                                        scope.$index + 1
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "位置名称",
                                        prop: "stallName",
                                        "min-width": "150",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row.stallName || "-"
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "位置描述",
                                        prop: "stallRemark",
                                        "min-width": "200",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row.stallRemark ||
                                                        "-"
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _c("div", { staticClass: "no-stalls" }, [
                              _c("span", [_vm._v("该区域暂无位置信息")]),
                            ]),
                      ]),
                    ]
                  )
                }),
                0
              )
            : _c("div", { staticClass: "no-data" }, [
                _c("span", [_vm._v("暂无摊位设置信息")]),
              ]),
          _vm.marketData.marketLayoutImg
            ? _c("div", { staticClass: "layout-images" }, [
                _c("div", { staticClass: "subsection-title" }, [
                  _vm._v("摊位分布图"),
                ]),
                _c(
                  "div",
                  { staticClass: "image-gallery" },
                  _vm._l(
                    _vm.getImageList(_vm.marketData.marketLayoutImg),
                    function (img, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "image-item" },
                        [
                          _c("el-image", {
                            staticStyle: {
                              width: "120px",
                              height: "120px",
                              "border-radius": "6px",
                            },
                            attrs: {
                              src: img,
                              "preview-src-list": _vm.getImageList(
                                _vm.marketData.marketLayoutImg
                              ),
                              fit: "cover",
                            },
                          }),
                        ],
                        1
                      )
                    }
                  ),
                  0
                ),
              ])
            : _c("div", { staticClass: "no-data" }, [
                _c("span", [_vm._v("暂无摊位分布图")]),
              ]),
        ]),
      ]),
      _c("div", { staticClass: "detail-section" }, [
        _vm._m(3),
        _c(
          "div",
          { staticClass: "section-content" },
          [
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c("el-col", { attrs: { span: 12 } }, [
                  _c("div", { staticClass: "detail-item" }, [
                    _c("label", [_vm._v("客户类型：")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.marketData.customerType || "-")),
                    ]),
                  ]),
                ]),
                _c("el-col", { attrs: { span: 12 } }, [
                  _c("div", { staticClass: "detail-item" }, [
                    _c("label", [_vm._v("日均客流量：")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.marketData.dailyVisitorCount || "-")),
                    ]),
                  ]),
                ]),
                _c("el-col", { attrs: { span: 24 } }, [
                  _c("div", { staticClass: "detail-item facilities-item" }, [
                    _c("label", [_vm._v("集市设施：")]),
                    _vm.marketData.marketSupporting
                      ? _c(
                          "div",
                          { staticClass: "facilities-list" },
                          _vm._l(
                            _vm.getFacilitiesList(
                              _vm.marketData.marketSupporting
                            ),
                            function (facility) {
                              return _c(
                                "el-tag",
                                {
                                  key: facility,
                                  staticStyle: {
                                    "margin-right": "8px",
                                    "margin-bottom": "4px",
                                  },
                                  attrs: { size: "mini" },
                                },
                                [_vm._v(" " + _vm._s(facility) + " ")]
                              )
                            }
                          ),
                          1
                        )
                      : _c("span", [_vm._v("-")]),
                  ]),
                ]),
              ],
              1
            ),
            _vm.marketData.marketImg
              ? _c("div", { staticClass: "market-images" }, [
                  _c("div", { staticClass: "subsection-title" }, [
                    _vm._v("集市图片"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "image-gallery" },
                    _vm._l(
                      _vm.getImageList(_vm.marketData.marketImg),
                      function (img, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "image-item" },
                          [
                            _c("el-image", {
                              staticStyle: {
                                width: "120px",
                                height: "120px",
                                "border-radius": "6px",
                              },
                              attrs: {
                                src: img,
                                "preview-src-list": _vm.getImageList(
                                  _vm.marketData.marketImg
                                ),
                                fit: "cover",
                              },
                            }),
                          ],
                          1
                        )
                      }
                    ),
                    0
                  ),
                ])
              : _c("div", { staticClass: "no-data" }, [
                  _c("span", [_vm._v("暂无集市图片")]),
                ]),
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c("el-col", { attrs: { span: 24 } }, [
                  _c("div", { staticClass: "detail-item description-item" }, [
                    _c("label", [_vm._v("集市描述：")]),
                    _c("div", { staticClass: "description-text" }, [
                      _vm._v(_vm._s(_vm.marketData.marketInfo || "-")),
                    ]),
                  ]),
                ]),
                _c("el-col", { attrs: { span: 12 } }, [
                  _c("div", { staticClass: "detail-item" }, [
                    _c("label", [_vm._v("集市联系人：")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.marketData.contactPerson || "-")),
                    ]),
                  ]),
                ]),
                _c("el-col", { attrs: { span: 12 } }, [
                  _c("div", { staticClass: "detail-item" }, [
                    _c("label", [_vm._v("集市联系电话：")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.marketData.contactPhone || "-")),
                    ]),
                  ]),
                ]),
                _c("el-col", { attrs: { span: 12 } }, [
                  _c("div", { staticClass: "detail-item qr-item" }, [
                    _c("label", [_vm._v("集市主微信二维码：")]),
                    _vm.marketData.marketOwnerPhoto
                      ? _c(
                          "div",
                          { staticClass: "qr-image" },
                          [
                            _c("el-image", {
                              attrs: {
                                src: _vm.marketData.marketOwnerPhoto,
                                "preview-src-list": [
                                  _vm.marketData.marketOwnerPhoto,
                                ],
                                fit: "cover",
                              },
                            }),
                          ],
                          1
                        )
                      : _c("span", [_vm._v("-")]),
                  ]),
                ]),
                _vm.marketData.remark
                  ? _c("el-col", { attrs: { span: 24 } }, [
                      _c("div", { staticClass: "detail-item remark-item" }, [
                        _c("label", [_vm._v("备注信息：")]),
                        _c("div", { staticClass: "description-text" }, [
                          _vm._v(_vm._s(_vm.marketData.remark)),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-title" }, [
      _c("i", { staticClass: "el-icon-info" }),
      _c("span", [_vm._v("基础信息")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-title" }, [
      _c("i", { staticClass: "el-icon-s-grid" }),
      _c("span", [_vm._v("摊位信息")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stall-title" }, [
      _c("h4", [_vm._v("位置列表")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-title" }, [
      _c("i", { staticClass: "el-icon-document" }),
      _c("span", [_vm._v("详细信息")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }